import styled from "styled-components";

export const StyledStatusLiveStamp = styled.span`
  padding: 2px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.figma.base.color_freshred_100};
  color: ${(props) => props.theme.figma.base.color_white_100};
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_micro};
  font-size: ${(props) => props.theme.mixins.pxToRem(10)};
  font-weight: ${(props) => props.theme.figma.base.fontweight_bold};
  border-radius: ${(props) =>
    props.theme.mixins.pxToRem(props.theme.figma.base.scale_2_50)};
  text-transform: uppercase;
  .mls-c-status-stamp__status--delay {
    background-color: ${(props) => props.theme.figma.base.color_white_10};
  }
`;
export const StyledStatusExtraStamp = styled.span`
  opacity: 0.75;
  margin-left: 2px;
`;
